import { FEATURES } from "@/domain/erpFeatures";

/** Minimum permission to show a nav item (feature ∩ role grants resolved at login). */
const NAV_ITEM_ACCESS = {
  "/app/orders": { permission: "customer.orders.read", feature: FEATURES.ORDERS },
  "/app/trips": { permission: "customer.trips.read", feature: FEATURES.TRIPS },
  "/app/pod": { permission: "customer.pod.read", feature: FEATURES.POD },
  "/app/invoices": {
    permission: "customer.finance.read",
    feature: FEATURES.FINANCE,
  },
  "/app/finance/ledger": {
    permission: "customer.finance.read",
    feature: FEATURES.FINANCE,
  },
  "/app/finance/ageing": {
    permission: "customer.finance.read",
    feature: FEATURES.FINANCE,
  },
  "/app/workshop": { feature: FEATURES.WORKSHOP },
  "/app/fleet": { feature: FEATURES.FLEET },
  "/app/insights": { feature: FEATURES.INSIGHTS },
  "/app/admin/access": { permission: "customer.tenant.users" },
  "/app/admin/customer-permissions": { permission: "customer.tenant.roles" },
};

function navAccessMeta(href) {
  return NAV_ITEM_ACCESS[href] ?? {};
}

export { navAccessMeta };
